<template>
<div class="chapter">
<div class="inner_page">
<p class="imagec" id="part01"><img alt="Image" src="images/f0015-01.jpg"/></p>
<h1 class="h1"><a id="page_15"><strong>Part I</strong></a></h1><a id="page_15">
<p class="h1b">Understanding the Online Domain</p>
</a><p class="noindent"><a id="page_15"></a><a id="page_16"></a></p><a id="page_16">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?0f593918